//@flow
import React from 'react';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import CustomTextField from '../../../../elements/CustomTextField/CustomTextField';

import type {User} from '../../../../entities';
import type {ErrorOption, Control} from 'react-hook-form';

type Props = {
  user: User,
  errors: ErrorOption,
  register: any => void,
  control: Control,
};

export default function AccountConfig(props: Props) {
  const {user, errors, register} = props;

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6}>
        <CustomTextField
          label="Nombre"
          fullWidth
          name="firstName"
          error={!!errors.firstName}
          helperText={errors.firstName ? errors.firstName.message : ''}
          inputRef={register({
            required: 'Campo obligatorio',
          })}
          defaultValue={user.firstName}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <CustomTextField
          label="Apellido"
          fullWidth
          name="lastName"
          error={!!errors.lastName}
          helperText={errors.lastName ? errors.lastName.message : ''}
          inputRef={register({
            required: 'Campo obligatorio',
          })}
          defaultValue={user.lastName}
        />
      </Grid>
    </Grid>
  );
}

AccountConfig.propTypes = {
  user: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  register: PropTypes.func.isRequired,
  control: PropTypes.object.isRequired,
};
